import { css } from '@emotion/core'

export default ({ theme: { colors } }) => css`
  @keyframes fadeout {
    from {
      opacity: 1;
      z-index: 9999;
    }
    to {
      opacity: 0;
      z-index: 0;
    }
  }

  &.fetching {
    .loader {
      z-index: 9999;
    }
  }

  &.fetched {
    .loader {
      animation: fadeout 600ms linear;
    }
  }

  width: 100%;
  height: 100%;
  padding-top: 4rem;
  background-color: rgba(255, 255, 255, 0.65);
  display: flex;

  align-items: flex-start;
  padding-top: 4rem;
  z-index: 99;
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }

  .spinner {
    top: 40%;
    margin: 100px auto 0;
    width: 70px;
    text-align: center;
    position: relative;
  }

  .spinner > div {
    width: 18px;
    height: 18px;
    background-color: #333;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  opacity: 0;

  &.show-spinner {
    opacity: 1;
  }
`
